import { Component, EventEmitter, Input, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Listing, TrackingService, EVENTS, ListingService, RatehawkService, AuthService, IUser, GeneralService, DataStoreService } from '@clooper/core';
import { faHeart, faMapMarkerAlt, faArrowLeft, faArrowRight, faBadgeCheck, faBed, faBath, faLeaf } from '@fortawesome/pro-light-svg-icons';
import * as lozad from 'lozad'
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HotelRoomListsComponent } from '@clooper/common';

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {
  @Input() listing: Listing;
  @Input() queryParams: any = { checkIn: 0, checkOut: 0, guests: [], currency: '' }

  @Output() likedProperty = new EventEmitter()
  user: IUser
  icons = {
    map: faMapMarkerAlt,
    bed: faBed,
    bath: faBath,
    trusted: faBadgeCheck,
    arrowRight: faArrowRight,
    arrowLeft: faArrowLeft,
    heart: faHeart,
    leave: faLeaf,



  }
  bsModalRef?: BsModalRef;

  trustedString: string = 'This supplier is a member of a trade association or has been awarded ISO standards and is committed to providing high quality properties'
  favourite = false;
  max = 1;
  rate = 0;
  isReadonly = true;
  starRating: any;
  showBenchMark: boolean = false;
  selectedCurrency: string = "GBP";


  constructor(
    private router: Router,
    private tracker: TrackingService,
    private toastr: ToastrService,
    private service: ListingService,
    private ratehawk: RatehawkService,
    private gs: GeneralService,
    private listingService: ListingService,
    private modalService: BsModalService,
    private storage: DataStoreService,
    @Optional() private authService: AuthService

  ) { }

  ngOnInit(): void {
    this.user = this.authService.getAuthorizedUser()
    setTimeout(() => {
      const observer = lozad();
      observer.observe();
    }, 100);
    if (this.listing.liked === true) {
      this.favourite = true;
    } else if (this.listing.likes) {
      this.getPropertyLikeForAUser(this.listing.likes)
    }
    this.rate = this.listing?.review_rating;
    this.starRating = this.listing?.star_rating;
    // console.log(this.listing?.rent?.clooper_savings_percentage)
    if (this.listing?.rent?.clooper_savings_percentage !== undefined && this.listing?.rent?.clooper_savings_percentage > 2) {
      this.showBenchMark = true;
    }


  }


  async viewProperty(id: string) {
    if (await this.storage.get("currency") !== null) {

      this.selectedCurrency = await this.storage.get("currency")
    } else {
      this.selectedCurrency = this.selectedCurrency
    }
    const { checkIn, checkOut, adults, children, pets, infants, guests } = this.queryParams
              const guestsQS = this.buildGuestsQueryString(guests);
      window.open(`/listings/${id}?checkIn=${checkIn}&checkOut=${checkOut}${guestsQS ? `&${guestsQS}` : ""}`, '_blank'); // tx is the tracking parameter for ratehawk

    // window.open(`/listings/${id}?checkIn=${checkIn}&checkOut=${checkOut}&currency=${this.selectedCurrency}&adults=${adults}&children=${children}&pets=${pets}&infants=${infants}`, '_blank');
    const data = { route: this.router.url, id: id, app: 'Webapp' };
    this.tracker.track(EVENTS.VIEW_PROPERTY, data)
  }


  carouselClicks(platform: string, name: any) {
    const data = { route: this.router.url, platform, name };
    this.tracker.track(EVENTS.CLICK_LISTING_CAROUSELS, data)

  }

  getPropertyLikeForAUser(id: string[]) {
    id.forEach(element => {
      if (element === this.user.id) {
        this.favourite = true;
      }
    });


  }

  toggleFavouriteProperty(id: string, favourite: boolean) {
    if (this.favourite === false) {
      const payload = {
        toggle: true
      }
      this.service.toggleFavoriteProperty(payload, id).subscribe((res: Listing) => {
        this.favourite = true;
        const newData: Listing = this.listing;
        newData.likes = res.likes
        this.ngOnInit()


      }, err => {
        this.toastr.error(this.gs.getErrMsg(err))
      })

    } else {
      const payload = {
      }
      this.service.toggleFavoriteProperty(payload, id).subscribe((res: any) => {
        this.favourite = false;
        const newData: Listing = this.listing;
        newData.likes = res.likes
        // this.likedProperty.emit(newData)

        this.ngOnInit()


      }, err => {
        this.toastr.error(this.gs.getErrMsg(err))
      })

    }
  }

  openRoomModal(id: any, platform: string) {
    // console.log(id)
    sessionStorage.setItem('li_id', id)
    console.log(platform)
    if (platform === 'clp-pl') {

      this.listingService.getPricelinePropertyCOntract({ id }).subscribe((res: any) => {
        // console.log(res)
        const initialState = { edit: true, room: res.data.rooms }
        const roomId = res.data.rooms[0].rate_data[0].ppn_bundle
        // console.log(roomId)
        const { checkIn, checkOut, rooms, adults, children, pets, infants } = this.queryParams
        window.open(`/listings/hotel-apartment/${roomId}?checkIn=${checkIn}&checkOut=${checkOut}&adults=${adults}&children=${children}&pets=${pets}&infants=${infants}&rooms=${rooms}`, '_blank');
        const data = { route: this.router.url, id: id, app: 'Website' };
        this.tracker.track(EVENTS.VIEW_PROPERTY, data)
  
        // const options: any = {initialState, class: 'modal-rounded', ignoreBackdropClick: true }
        // this.bsModalRef =  this.modalService.show(HotelRoomListModalComponent, options)
        // this.bsModalRef =  this.modalService.show(HotelRoomListsComponent, options)
  
      })
    } else {
      const { checkIn, checkOut, guests  } = this.queryParams
          const guestsQS = this.buildGuestsQueryString(guests);

      window.open(`/listings/hotel-apartments/${id}?checkIn=${checkIn}&checkOut=${checkOut}${guestsQS ? `&${guestsQS}` : ""}&tx=${'rk'}`, '_blank'); // tx is the tracking parameter for ratehawk
      // const { checkIn, checkOut, rooms, adults, children, pets, infants } = this.queryParams

    
    }
  }

  
  buildGuestsQueryString(guests: any): string {
    const rooms = guests ?? guests ?? [];
    const parts: string[] = [];
  
    rooms.forEach((room: any, i: number) => {
      parts.push(`guests[${i}][adults]=${Number(room.adults ?? 0)}`);
  
      const children = Array.isArray(room.children) ? room.children : [];
      parts.push(`guests[${i}][children]=[${children.map(Number).join(",")}]`);
    });
  
    return parts.join("&");
  }

}
